import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {tryLoadUsers} from "../../../redux/slices/manageUserSlice";
import CustomTableItemLoader from "../../../components/CustomTableItemLoader";
import {tryLoadFeatures} from "../../../redux/slices/permissionSlice";
import AddFeatureTableItem from "./AddFeatureTableItem";

export default function AddFeatureTable() {

  const {
    loading = false, init = false, data: features = [], error = ""

  } = useSelector((state) => state.permission.features);

  const dispatch = useDispatch();


  useEffect(() => {
    if (!init && !loading && !error)
      dispatch(tryLoadFeatures());
  }, [init, loading, error]);


  return (
    <>
      {
        init && !!features.length ? <tbody>

          <AddFeatureTableContent features={features}/>
          </tbody> :
          <CustomTableItemLoader colSpan={3} loading={loading} error={error} isEmpty={init && !features.length} count={10}
                                 retry={() => dispatch(tryLoadUsers())}/>
      }

    </>
  );
}

const AddFeatureTableContent = ({features}) => {

  return (
    <>
      {


        features.map((feature) => {
            return <AddFeatureTableItem feature={feature} key={feature.id}/>;
          })
      }
    </>

  );
};
